var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiIntegrationDisable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9 2.34315 10.3431 1 12 1V1C13.6569 1 15 2.34315 15 4V4C15 5.65685 13.6569 7 12 7H9.07362C9.03296 7 9 6.96704 9 6.92638V4Z",
    stroke: "#C4D7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C9 13.2091 7.20914 15 5 15V15C2.79086 15 0.999999 13.2091 0.999999 11V11C1 8.79086 2.79086 7 5 7L9 7L9 11Z",
    stroke: "#C4D7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiIntegrationDisable);
export default __webpack_public_path__ + "static/media/ci-integration-disable.8e16e191df014170f8fd7c3f31e21c3c.svg";
export { ForwardRef as ReactComponent };